var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43203 14.6L16.482 7.55L15.082 6.15L9.43203 11.8L6.58203 8.95L5.18203 10.35L9.43203 14.6ZM10.832 20C9.4487 20 8.1487 19.7375 6.93203 19.2125C5.71536 18.6875 4.65703 17.975 3.75703 17.075C2.85703 16.175 2.14453 15.1167 1.61953 13.9C1.09453 12.6833 0.832031 11.3833 0.832031 10C0.832031 8.61667 1.09453 7.31667 1.61953 6.1C2.14453 4.88333 2.85703 3.825 3.75703 2.925C4.65703 2.025 5.71536 1.3125 6.93203 0.7875C8.1487 0.2625 9.4487 0 10.832 0C12.2154 0 13.5154 0.2625 14.732 0.7875C15.9487 1.3125 17.007 2.025 17.907 2.925C18.807 3.825 19.5195 4.88333 20.0445 6.1C20.5695 7.31667 20.832 8.61667 20.832 10C20.832 11.3833 20.5695 12.6833 20.0445 13.9C19.5195 15.1167 18.807 16.175 17.907 17.075C17.007 17.975 15.9487 18.6875 14.732 19.2125C13.5154 19.7375 12.2154 20 10.832 20ZM10.832 18C13.0654 18 14.957 17.225 16.507 15.675C18.057 14.125 18.832 12.2333 18.832 10C18.832 7.76667 18.057 5.875 16.507 4.325C14.957 2.775 13.0654 2 10.832 2C8.5987 2 6.70703 2.775 5.15703 4.325C3.60703 5.875 2.83203 7.76667 2.83203 10C2.83203 12.2333 3.60703 14.125 5.15703 15.675C6.70703 17.225 8.5987 18 10.832 18Z",
    fill: "url(#paint0_linear_1180_921)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1180_921",
    x1: 0.469164,
    y1: 10.4196,
    x2: 21.158,
    y2: 10.4196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.c3248b5a4c5bee3c13ca7cd42b3a3f45.svg";
export { ForwardRef as ReactComponent };